import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Popover, PopoverContent, PopoverTrigger } from '@achra/ui/popover';
import { Ellipsis } from 'lucide-react';
import type { BuilderSkill } from '@/modules/__generated__/graphql/switchboard-generated';
import { BuildersSkillsChip } from '@/modules/shared/components/chips/builders-skills-chip';
import { GenericChip } from '@/modules/shared/components/chips/generic-chip/generic-chip';
interface SkillsPopoverProps {
  skills: BuilderSkill[];
  className?: string;
}
function SkillsPopover(t0) {
  const $ = _c(12);
  const {
    skills,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("h-full w-8 cursor-pointer justify-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Ellipsis className="size-4" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <PopoverTrigger asChild={true}><GenericChip variant="underline" color="gray" className={t1} aria-label="Show all skills">{t2}</GenericChip></PopoverTrigger>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== skills) {
    t4 = skills.map(_temp);
    $[5] = skills;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <PopoverContent className="w-fit p-2" align="start"><div className="flex flex-col gap-1">{t4}</div></PopoverContent>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <Popover>{t3}{t5}</Popover>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp(skill) {
  return <BuildersSkillsChip key={skill} skill={skill} />;
}
export { SkillsPopover };